import { waitForElem } from '../../utils/wait_for_elem';

// Select "authorizations" type and scroll into view
waitForElem('#authorizations').then(() => {
  document.getElementById('authorizations')?.addEventListener('click', (e) => {
    e.preventDefault();
    (document.querySelector('input[value="authorization"]') as HTMLInputElement).checked = false;
    (document.querySelector('input[value="certificate"]') as HTMLInputElement).checked = false;
    (document.querySelector('input[value="authorization"]') as HTMLInputElement).click();
    document.getElementById('assets')?.scrollIntoView()
  });
});

// Select "certificates" type and scroll into view
waitForElem('#certificates').then(() => {
  document.getElementById('certificates')?.addEventListener('click', (e) => {
    e.preventDefault();
    (document.querySelector('input[value="authorization"]') as HTMLInputElement).checked = false;
    (document.querySelector('input[value="certificate"]') as HTMLInputElement).checked = false;
    (document.querySelector('input[value="certificate"]') as HTMLInputElement).click();
    document.getElementById('assets')?.scrollIntoView()
  });
});
